module.exports = __webpack_public_path__ + "assets/img/image(1).43d2d448.png";